import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type CategoryAttributeInput = {
  name: string;
  description: string;
  dataType: string;
  required: boolean;
  validationExpr?: string | null;
  options?: string[] | null;
};

export const categoryUpdateAtom = createMutationAtomFactory(
  'settings.categoryUpdate',
  (params: {
    id: string;
    name?: string | null;
    description?: string | null;
    attributes?: Record<string, CategoryAttributeInput> | null;
  }) => ({
    inventoryCategoryUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          description: params.description,
          attributes: params.attributes,
        },
      },
      id: true,
      name: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
